var Curriculog = Curriculog || {};

Curriculog.CurriculogView = (function ($, _, Backbone, CurriculogView) {

    CurriculogView = Backbone.View.extend({

        /**
         * Replaces a views current el with a new one. This also rebinds all
         *     event handlers bound using the {events} object and using view.listenTo().
         *
         * @param {Element} el - The new element
         * @returns {this} - For chaining
         */
        replaceElement: function (el) {
            var old = this.$el;
            this.setElement(el);
            old.replaceWith(this.$el);
            return this;
        },

        /**
         * @todo make these do what they say they do and not just manipulate classes
         */
        show: function () {
            this.$el.addClass('active');
        },

        /**
         * @todo make these do what they say they do and not just manipulate classes
         */
        hide: function () {
            this.$el.removeClass('active');
        },

        /**
         * Pops a persistant warning growl
         *
         * @param {String} [title] - Optional for ass backwards compatability. Seriously, this is the first arg
         * @param {String} message - The body of the growl
         * @returns {this} - For chaining
         */
        showGrowl: function (title, message) {
            //for backwards compatability, allow no title to be specified
            message = message || title;
            $('#growls').notify(
                'create', 'warning-template',
                {
                    title: title,
                    text: message
                },
                {expires: false}
            );
            return this;
        },

        /**
         * Adds a loading mask to an element
         *
         * @param {Element} element       - The element to mask over
         * @param {String}  [msg]         - Defaults to "Loading"
         * @param {Number}  [topPosition] - Top offset, defaults to calculated middle.
         * @returns {this} - For chaining
         */
        addMask: function(element, msg, topPosition) {
            msg = msg || 'Loading';
            element = $(element);
            element.mask(msg);

            if (topPosition) {
                element.find('.loadmask-msg').css('top', topPosition + 'px');
            }
            return this;
        },

        /**
         * Removes any loading mask from an element
         *
         * @param  {Element} $element      - The element to mask over
         * @return {this} - For chaining
         */
        removeMask: function($element) {
            $element = $($element);
            $element.unmask();
            return this;
        },

        /**
         * Updates a loading mask on an element
         *
         * @param {Element} element       - The element that has the mask
         * @param {String}  msg           - The message to change to
         * @returns {this} - For chaining
         */
        updateMask: function(element, msg, topPosition) {
            $(element).find('.loadmask-msg>div').text(msg);

            return this;
        },

        /**
         * Stops an event in its tracks.
         *
         * @param  {Event}   [event] - the event to stop
         * @param  {Boolean} [stop_immediate] - If true, stops any more handlers
         *     on the same dom level from picking up the event
         * @return {this} - for chaining... or whatnot
         */
        stopEvent: function(event, stop_immediate) {
            if (!event) return event;
            event.preventDefault();
            event.stopPropagation();
            if (stop_immediate) {
                event.stopImmediatePropagation();
            }
            return this;
        }

    });
    return CurriculogView;

})($, _, Backbone, Curriculog.CurriculogView || {});
